import React from "react";
import { MapPinIcon } from "lucide-react";
import { business } from "../../data/business";
import { PulseDot } from "../ui/PulseDot";
export function UtilityBar() {
  return <div className="gutter border-b border-white/10 bg-navy-900 text-[0.8rem] text-white/75" data-id="element-405" data-mp="2ai7zsksetw9h">
      <div className="flex min-h-[36px] items-center justify-between gap-6 py-1.5" data-id="element-406" data-mp="25j4ur0cfjq1i">
        <p className="flex items-center gap-2.5" data-id="element-407" data-mp="25lhbja6gbucz">
          <PulseDot data-id="element-408" data-mp="1hulosrgurpcl" />
          <span className="hidden sm:inline" data-id="element-409" data-mp="1hu2ffz59q9a6">Open Now — 24 Hours a Day, 7 Days a Week, 365 Days a Year</span>
          <span className="sm:hidden" data-id="element-410" data-mp="1dtry5qc0zwg0">Open Now — 24/7/365</span>
        </p>
        <div className="hidden items-center gap-5 lg:flex" data-id="element-411" data-mp="1rsjbhaj2de33">
          <a href={business.mapsUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 transition-colors duration-150 hover:text-gold-soft" data-id="element-412" data-mp="1mswy9138jxua">
            <MapPinIcon className="h-3.5 w-3.5" strokeWidth={1.5} aria-hidden="true" data-id="element-413" data-mp="2y6r0ae57x4r0" />
            {business.address}
          </a>
          <span className="h-3 w-px bg-white/20" aria-hidden="true" data-id="element-414" data-mp="1yn2tnntxxh99" />
          <span data-id="element-415" data-mp="23le33xgbppqy">Licensed Nevada Bail Agent — Lic. # {business.license}</span>
        </div>
        <a href={business.phoneHref} className="font-semibold text-gold-soft sm:hidden" data-id="element-416" data-mp="28l8oxml8rp55">
          {business.phoneDisplay}
        </a>
      </div>
    </div>;
}